import { renderMetaTags } from 'react-datocms';

import Head from 'next/head';

export default function Metadata({ data }: { data: any }) {
  // eslint-disable-next-line no-unsafe-optional-chaining
  return <Head>{renderMetaTags([...data?.site?.favicon, ...data?.page?.seo])}</Head>;
}
